"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.China = void 0;
exports.China = {
    id: 'fhchina',
    companyName: 'China',
    transportModes: ['sea', 'air'],
    freightGate: {
        isOnboarded: true,
        realm: 'fhchina',
    },
    isInternal: true,
    isActive: true,
    countries: ['CN'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2hpbmEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvYWdlbnRzL2RhdGEvQ2hpbmEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxLQUFLLEdBQVU7SUFDeEIsRUFBRSxFQUFFLFNBQVM7SUFDYixXQUFXLEVBQUUsT0FBTztJQUNwQixjQUFjLEVBQUUsQ0FBQyxLQUFLLEVBQUUsS0FBSyxDQUFDO0lBQzlCLFdBQVcsRUFBRTtRQUNULFdBQVcsRUFBRSxJQUFJO1FBQ2pCLEtBQUssRUFBRSxTQUFTO0tBQ25CO0lBQ0QsVUFBVSxFQUFFLElBQUk7SUFDaEIsUUFBUSxFQUFFLElBQUk7SUFDZCxTQUFTLEVBQUUsQ0FBQyxJQUFJLENBQUM7Q0FDcEIsQ0FBQSJ9